import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { globalFileServer } from "../../../../axiosInstance";
import { setProducts } from "../../../server/Product";

const ProductFilterInside = ({
  parameterName,
  selectedFilters,
  setSelectedFilters,
}) => {
  const dispatch = useDispatch();
  const { itemsShow, reloed } = useSelector((state) => ({
    itemsShow: state.displayProduct.itemsShow,
    reloed: state.displayProduct.reloed,
  }));
  const [originalItems, setOriginalItems] = useState();
  const [quantityMap, setQuantityMap] = useState({});

  useEffect(() => {
    if (!reloed) {
      setSelectedFilters([]);
      setOriginalItems(itemsShow);
      setQuantityMap(buildEntityCountMap(itemsShow));
    }
  }, [reloed]);

  useEffect(() => {
    const filtersWitoutMe = selectedFilters.filter(
      (f) => f.parameterName !== parameterName,
    );
    setQuantityMap(
      buildEntityCountMap(applyAllFilters(originalItems, filtersWitoutMe)),
    );
  }, [selectedFilters]);

  const getValueByPath = (obj, name) => {
    if (!obj || !name) return undefined;
    return name
      .replace(/\[(\d+)\]/g, ".$1")
      .split(".")
      .reduce((acc, key) => acc?.[key], obj);
  };

  const buildEntityCountMap = (categoryNode, map = {}) => {
    if (!categoryNode) return map;

    if (Array.isArray(categoryNode.products)) {
      categoryNode.products.forEach((product) => {
        const entity = getValueByPath(product, parameterName);
        if (
          parameterName !== "kosherSupervision[0].classification" &&
          !entity?.id
        )
          return;

        const key = String(
          parameterName !== "kosherSupervision[0].classification"
            ? entity.id
            : entity,
        );

        if (!map[key]) {
          map[key] = {
            id:
              parameterName !== "kosherSupervision[0].classification"
                ? entity.id
                : entity,
            name:
              parameterName !== "kosherSupervision[0].classification"
                ? entity.name
                : entity,
            quantity: 1,
          };
        } else {
          map[key].quantity += 1;
        }
      });
    }

    if (Array.isArray(categoryNode.children)) {
      categoryNode.children.forEach((child) => buildEntityCountMap(child, map));
    }

    return map;
  };

  const filterCategoryTreeByParameter = (
    categoryNode,
    parameterName,
    wantedIds,
  ) => {
    if (!categoryNode) return null;

    let filteredProducts = [];
    if (Array.isArray(categoryNode.products)) {
      filteredProducts = categoryNode.products.filter((product) => {
        const entity = getValueByPath(product, parameterName);
        return (
          (entity && entity.id && wantedIds.includes(entity.id)) ||
          (parameterName === "kosherSupervision[0].classification" &&
            wantedIds.includes(entity))
        );
      });
    }

    let filteredChildren = [];
    if (Array.isArray(categoryNode.children)) {
      filteredChildren = categoryNode.children
        .map((child) =>
          filterCategoryTreeByParameter(child, parameterName, wantedIds),
        )
        .filter(Boolean);
    }

    if (!filteredProducts.length && !filteredChildren.length) {
      return null;
    }

    return {
      ...categoryNode,
      products: filteredProducts,
      children: filteredChildren,
    };
  };

  const applyAllFilters = (tree, filters) => {
    let result = tree;

    const grouped = filters.reduce((acc, { parameterName, id }) => {
      if (!acc[parameterName]) acc[parameterName] = [];
      acc[parameterName].push(id);
      return acc;
    }, {});

    Object.entries(grouped).forEach(([parameterName, ids]) => {
      if (!result) return;
      result = filterCategoryTreeByParameter(result, parameterName, ids);
    });

    return result;
  };

  const toggleFilter = (selectedId) => {
    const exists = selectedFilters.some(
      (f) => f.parameterName === parameterName && f.id === selectedId,
    );

    let newFilters;
    if (exists) {
      newFilters = selectedFilters.filter(
        (f) => !(f.parameterName === parameterName && f.id === selectedId),
      );
    } else {
      newFilters = [...selectedFilters, { parameterName, id: selectedId }];
    }

    const filteredItemsShow = applyAllFilters(originalItems, newFilters);

    dispatch(setProducts(filteredItemsShow));
    setSelectedFilters(newFilters);
  };

  return (
    <ul>
      {Object.entries(quantityMap).map(([key, { id, name, quantity }]) => {
        return (
          <li
            key={id}
            data-class={!quantity ? "disabled" : null}
            className={
              selectedFilters.some(
                (x) => x.id === id && x.parameterName === parameterName,
              )
                ? "active"
                : null
            }
          >
            <span>{name}</span>
            <span className="quantity">{"(" + quantity + ")"}</span>
            <div
              className="input"
              onClick={() => (quantity ? toggleFilter(id) : null)}
            >
              {selectedFilters.some(
                (x) => x.id === id && x.parameterName === parameterName,
              ) ? (
                <img
                  loading="lazy"
                  src={globalFileServer + "iconcss/done.svg"}
                  alt="done"
                />
              ) : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default ProductFilterInside;
